import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function CpcModal() {
	return (
		<div className='performance_item_modal cpc_modal'>
			<h3>CPC</h3>
			<p>
				For performance advertisers, Cost Per Click is one of the most watched indicators of campaign success.
			</p>
			<p>
				However a low CPC is not necessarily indicative of overall campaign performance.
			</p>
			<p>
				If you are optimizing for awareness or going after a premium audience, CPCs will tend to rise.
			</p>
		</div>
	)
}

const renderCpcBody = (value, global, us) => {
	if(value===null) {
		return (
			<p>Since you have no spend during the past 30 days, we couldn&apos;t calculate your CPC!</p>
		)
	} else {
		const formatPercent = (num) => { return num.toLocaleString('en', {style: 'percent'}) }
		let currencyStr = parseFloat(value).toLocaleString('en-US', {style: 'currency', currency: 'USD'})
		let globalDiff = formatPercent(Math.abs(global-value)/ global)
		let globalLowHigh = value > global ? 'higher' : 'lower'
		let domesticDiff = formatPercent(Math.abs(us-value)/ us)
		let domesticLowHigh = value > us ? 'higher' : 'lower'
		return (
			<p>Your CPC is {currencyStr} which is {domesticDiff} {domesticLowHigh} than the U.S. industry average and {globalDiff} {globalLowHigh} than the global average.</p>
		)
	}
}

function CpcPerformanceItem(props) {
	const { score, maxScore, value, benchmark: { global, us } } = props.apiScore
	
	// {"cpc":{"score":0,"maxScore":18,"value":null,"benchmark":{"us":1.1,"global":0.54}}
	return (
		<PerformanceItem
			title="Cost Per Click"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('cpc') }}>
			{renderCpcBody(value, global, us)}
		</PerformanceItem>
	)
}

CpcPerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}

export { CpcModal, CpcPerformanceItem }


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/performance_items/Cpc.js